var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('iframe',{ref:"aboutIframe",staticStyle:{"border":"0px","padding":"0px","margin":"0px"},attrs:{"src":"../../static/about/index.html","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }